import { PYG } from "./available-currencies";

export const formatToPyg = (value: number): string => {
  return `₲${value.toLocaleString("es-PY")}`;
};

export const formatToUsd = (value: number): string => {
  return `$${value.toLocaleString("es-PY")}`;
};

export const formatToCurrency = (value: number, currency: string): string => {
  if (currency === PYG) {
    return formatToPyg(value);
  }
  return formatToUsd(value);
};
